export const commentActionTypes = {
    COMMENT_SUCCESS: 'COMMENT_SUCCESS',
}